import React, { useEffect } from 'react'
import { useState } from 'react'
import { Bars } from 'react-loader-spinner'
import { useParams } from 'react-router-dom'
// import Layout from '../../layout'
import characters from "../../assets/media/success/characters.png"
import postApi from '../../services/helpers/axios/apiCalls'
import { useNavigate, Link } from 'react-router-dom'


const Success = () => {
    const [candidateEmail] = useState(JSON.parse(localStorage.getItem('candidateEmail')))
    const navigate = useNavigate()
    const [loader, setloader] = useState(true)
    const { plan } = useParams()

    console.log("success page", plan)

    const plans = {
        free: "Free Trial".toUpperCase(),
        standard: "Standard Plan".toUpperCase(),
        premium: "Premium Plan".toUpperCase(),
    }

    useEffect(() => {

        if (plan === 'free') {
            setloader(false)

        }


        if (plan !== 'free') {
            const localSessionId = JSON.parse(localStorage.getItem('sessionId'))
            if (!localSessionId) {
                navigate('/')

            }

            let apiCallRequest = {
                url: "auth/pay/confrim-session-status",
                data: {
                    sessionId: localSessionId
                },
                config: {
                }
            }
            postApi(apiCallRequest).then((res) => {
                setloader(false)
                localStorage.removeItem('sessionId')
                console.log(res.data)
            }

            ).catch((e) =>
                console.log(e.message)

            )
        }


    }, [navigate, plan])

    return (

        <div className={`thankspopup-wrapper min-h-screen p-10 bg-[#333333] relative flex justify-center items-center`}>
            {

                loader ?
                    <Bars
                        height="80"
                        width="80"
                        color="#ffe501"
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                    :
                    <div className="conatiner w-[80vw] md:w-[70vw] lg:w-[50vw] xl:w-[50vw]  min-h-[90%] p-5 flex flex-col items-center justify-center">
                        {/* large */}
                        <div className="largeContainer bg-white border-8 border-[#FFB600]  w-[100%] rounded-xl h-auto flex flex-col items-center px-5">

                            <div className="text flex flex-col items-center mt-5">
                                <div className="heading font-bold text-[#FFB600] text-xl sm:text-[3vw] mt-5">Thank You!</div>
                                <div className="desc text-[14px] sm:text-[1.5vw] md:text-[1.5vw] lg:text-[1.2vw] mt-5 2xl:mt-10 text-center">You have successfully signed up for your <span className='font-semibold'>{plans[plan]}</span>. We have sent you an email with your log in details at <span className='text-[#FFB600]'>{candidateEmail}</span>
                                </div>
                                <Link to={'/'}>
                                    <div className="cta bg-[#FFB600] px-4 py-2 w-fit rounded-lg mt-5 2xl:mt-10 font-semibold text-[14px] sm:text-[1.5vw] md:text-[1.6vw] lg:text-[1vw] cursor-pointer">Go to Home Page</div>
                                </Link>
                                <div className="image w-full">
                                    <img src={characters} className="object-contain" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

            }


        </div>
    )
}

export default Success